<template>
  <div v-if="visible" id="tab-mbl2">
    <div class="section operations">
      <div v-show="cooperateEdit" class="triggers">
        <div>
          <el-dropdown
            no="1"
            :class="readonly?'not-click':''"
            split-button
            type="primary"
            style="margin-right: 5px"
            @click="commandHandle(command1)"
            @command="p=>{command1=p;commandHandle(command1)}"
          >
            {{ command1 }}
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="$t('SeaExport.CodeSearching')">{{ $t('SeaExport.CodeSearching') }}</el-dropdown-item>
              <el-dropdown-item :command="$t('SeaExport.CopyFromTheLastTime')">{{ $t('SeaExport.CopyFromTheLastTime') }}</el-dropdown-item>
              <el-dropdown-item :command="$t('SeaExport.CopyFromOtherBill')">{{ $t('SeaExport.CopyFromOtherBill') }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-checkbox v-model="form.edi" no="2" :disabled="readonly">EDI</el-checkbox>
          <el-checkbox v-model="form.oversea" no="3" :disabled="readonly" style="margin-left: -20px;">{{ $t('SeaExport.BlBeReleased') }}</el-checkbox>
        </div>
      </div>
    </div>
    <div style="display: flex">
      <div class="section form-column">
        <el-form label-width="70px" label-position="right" style="height:100%">
          <span class="title">{{ $t('SeaExport.ConsigneeShipperAndNotifyInfo') }}</span>
          <el-form-item :label="$t('Message.Shipper')" class="custom">
            <div style="display: flex">
              <el-input v-model="form.shipperCode" :disabled="readonly" no="4" style="flex:1" />
              <el-button no="5" :disabled="readonly" type="primary" style="margin-left: 5px" @click="clearSenderAndReceiver('shipper',7)">{{ $t('SeaExport.Reset') }}</el-button>
            </div>
          </el-form-item>
          <el-form-item
            v-for="count in 7"
            :key="'shipperLine'+count"
            :class="'custom ' + getSenderAndReceiverColor('shipperLine',count)"
          >
            <cargo-input
              :ref="'shipperLine'+count"
              v-model="form['shipperLine'+count]"
              :disabled="readonly"
              :no="'shipperLine'+count"
              :auto-uppercase="notUppercaseShipperConsigneNotify"
              :use-read-only="true"
              @dblclick.native="showSenderAndReceiverDialog('shipper',7, false, notUppercaseShipperConsigneNotify)"
              @change="()=>wrapAddr(form,'shipperLine'+count,count+1 > 7 ? null :'shipperLine'+(count+1),maxChars)"
            />
          </el-form-item>
          <el-form-item :label="$t('Message.Consignee')" class="custom">
            <div style="display: flex">
              <el-input v-model="form.consigneeCode" :disabled="readonly" no="6" style="flex: 1" />
              <el-button no="7" type="primary" :disabled="readonly" style="margin-left: 5px" @click="clearSenderAndReceiver('consignee',7)">{{ $t('SeaExport.Reset') }}</el-button>
            </div>
          </el-form-item>
          <el-form-item
            v-for="count in 7"
            :key="'consigneeLine'+count"
            :class="'custom ' + getSenderAndReceiverColor('consigneeLine',count)"
          >
            <cargo-input
              :ref="'consigneeLine'+count"
              v-model="form['consigneeLine'+count]"
              :disabled="readonly"
              :no="'consigneeLine'+count"
              :auto-uppercase="notUppercaseShipperConsigneNotify"
              :use-read-only="true"
              @dblclick.native="showSenderAndReceiverDialog('consignee',7,false, notUppercaseShipperConsigneNotify)"
              @change="()=>wrapAddr(form,'consigneeLine'+count,count+1 > 7 ? null :'consigneeLine'+(count+1),maxChars)"
            />
          </el-form-item>
          <el-form-item :label="$t('Message.Notify')" class="custom">
            <div style="display: flex;">
              <el-input v-model="form.notifyCode" :disabled="readonly" no="8" style="flex: 1;width: 100px" />
              <el-button no="9" :disabled="readonly" type="primary" style="margin-left: 5px" @click="clearSenderAndReceiver('notify',7)">{{ $t('SeaExport.Reset') }}</el-button>
              <el-button no="10" :disabled="readonly" type="primary" style="margin-left: 5px" @click="pm.onCopyConsignee()">{{ $t('SeaExport.CopyTheConsignee') }}</el-button>
            </div>
          </el-form-item>
          <el-form-item
            v-for="count in 7"
            :key="'notifyLine'+count"
            :class="'custom ' + getSenderAndReceiverColor('notifyLine',count)"
          >
            <cargo-input
              :ref="'notifyLine'+count"
              v-model="form['notifyLine'+count]"
              :disabled="readonly"
              :no="'notifyLine'+count"
              :auto-uppercase="notUppercaseShipperConsigneNotify"
              :use-read-only="true"
              @dblclick.native="showSenderAndReceiverDialog('notify',7,false, notUppercaseShipperConsigneNotify)"
              @change="()=>wrapAddr(form,'notifyLine'+count,count+1 > 7 ? null :'notifyLine'+(count+1),maxChars)"
            />
          </el-form-item>
          <el-form-item label-width="0" class="custom">
            <span style="color:#404144">ALSO NOTIFY</span>
          </el-form-item>
          <el-form-item class="custom">
            <cargo-rich-textarea
              v-model="form.alsoNotify"
              no="11"
              :disabled="!isEdit"
              :text-chars="maxChars"
              :warning-count="warningCount"
              style="height: 110px;"
              @dblclick.native="showAdvanceTextDialog('ALSO NOTIFY',form.alsoNotify,val=>{form.alsoNotify=val.toUpperCase()},false, null, notUppercaseShipperConsigneNotify)"
            />
          </el-form-item>
        </el-form>
      </div>
      <div class="section form-column">
        <el-form :disabled="readonly" label-width="85px" label-position="right" style="height:100%">
          <span class="title">{{ $t('SeaExport.CargoInfo') }}</span>
          <el-form-item :label="$t('SeaExport.NumberOfPackagesOnBl')">
            <auto-number-input
              v-model="form.quantity"
              no="12"
              :precision="0"
              :min="0"
              @change="pm.quantity_Change(form.quantity)"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.Package')" :class="variableCss.packing">
            <!-- <cargo-advance-select
              :select-type="selectTypeNames.basic_data_Packing"
              filterable
              :default-value="form.packing"
              style="width:100%;"
              @parentCallBack="p=>{pm.packing_Change(p)}"
            /> -->
            <cargo-packing-select
              no="13"
              :default-value="form.packing"
              @change="p => {pm.packing_Change(p)}"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.Pieces2')" :class="variableCss.insideQuantity">
            <auto-number-input
              v-model="form.insideQuantity"
              no="14"
              :precision="0"
              :min="0"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.PiecesType2')" :class="variableCss.insidePacking">
            <!-- <cargo-advance-select
              :select-type="selectTypeNames.basic_data_Packing"
              filterable
              :default-value="form.insidePacking"
              style="width:100%;"
              @parentCallBack="p=>{form.insidePacking=p.value}"
            /> -->
            <cargo-packing-select
              no="15"
              :default-value="form.insidePacking"
              @change="p => {form.insidePacking=p.value}"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.GrossWeight')" :class="'custom '+variableCss.weight">
            <div class="form-item-input" :class="readonly ? 'input-disabled': ''">
              <auto-number-input
                v-model="form.weight"
                no="16"
                :precision="3"
                :min="0"
              />
              <span>KGS</span>
            </div>
          </el-form-item>
          <el-form-item :label="$t('SeaExport.Cubage')" :class="'custom '+variableCss.cubage">
            <div class="form-item-input" :class="readonly ? 'input-disabled': ''">
              <auto-number-input
                v-model="form.cubage"
                no="17"
                :precision="3"
                :min="0"
              />
              <span>CBM</span>
            </div>
          </el-form-item>
          <el-form-item :label="$t('SeaExport.ChargedWeightRT')" class="custom">
            <div class="form-item-input" :class="readonly ? 'input-disabled': ''">
              <auto-number-input
                v-model="form.chargeWeight"
                no="18"
                :precision="3"
                :min="0"
              />
              <span>M/T</span>
            </div>
          </el-form-item>
          <el-form-item :label="$t('queryJob.englishDescriptionOfGoods')" :class="'label-none custom '+variableCss.cargoEnglishName">
            <cargo-rich-textarea
              v-model="form.cargoEnglishName"
              no="19"
              :disabled="!isEdit"
              :text-chars="0"
              :auto-uppercase="isUppercaseByConfig"
              style="height: 110px;"
              @dblclick.native="showAdvanceTextDialog($t('queryJob.englishDescriptionOfGoods'),form.cargoEnglishName,val=>{form.cargoEnglishName=val},false,null,isUppercaseByConfig , {
                warningCount: englishNameWarningCount,
                maxChar: englishNameMaxChars
              })"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.Marks')" :class="'label-none custom '+variableCss.mark">
            <cargo-rich-textarea
              v-model="form.mark"
              no="20"
              :disabled="!isEdit"
              :text-chars="0"
              :warning-count="22"
              :auto-uppercase="isUppercaseByConfig"
              style="height: 110px;"
              @dblclick.native="showAdvanceTextDialog($t('SeaExport.Marks'),form.mark,val=>{form.mark=val},false,null,isUppercaseByConfig , {
                warningCount: markWarningCount,
                maxChar: markMaxChars
              })"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.CapitalizedNumbersOfPackages')" class="label-none custom">
            <el-input v-model="form.quantitySum" no="21" :disabled="true" />
          </el-form-item>
        </el-form>
      </div>
      <div class="section form-column">
        <el-form :disabled="readonly" label-width="85px" label-position="right" style="height:100%">
          <span class="title">{{ $t('SeaExport.TransportInfo') }}</span>
          <el-form-item label="MB/L NO2.">
            <el-input v-model="form.mblNbr2" no="22" />
          </el-form-item>
          <el-form-item label="HB/L NO2.">
            <el-input no="23" :disabled="true" :value="form.hblNbr2" />
          </el-form-item>
          <el-form-item :label="$t('Payment.vesselAndVoyage')">
            <el-input no="24" :disabled="true" :value="txtFirstVesselVoyage" />
          </el-form-item>
          <el-form-item :label="$t('queryJob.dateOfDeparture')">
            <el-input no="25" :disabled="true" :value="moment(job.etd).format('YYYY-MM-DD')" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.DocDispatchingPlace')" :class="variableCss.dispatchingPlace">
            <el-input v-model="form.dispatchingPlace" no="26" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.PortOfLoadingOnBl')" :class="variableCss.loadingPort">
            <el-input v-model="form.loadingPort" no="27" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.PortOfDischargeOnBl')" :class="variableCss.dischargingPort">
            <el-input v-model="form.dischargingPort" no="28" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.PlaceOfDeliveryOnBl')" :class="variableCss.destinationPort">
            <el-input v-model="form.destinationPort" no="29" />
          </el-form-item>
          <!--            <el-form-item label="提单最终目的地">-->
          <!--              <el-input v-model="form.destinationPlace" />-->
          <!--            </el-form-item>-->
          <el-form-item :label="$t('SeaExport.MethodOfMblPayment')">
            <el-input
              no="30"
              :value="ColumnUtils.paymentTermLabelFunc(form.paymentTerm)"
              @input="val=>{form.paymentTerm=val}"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.PlaceOfMblPayment2')">
            <el-input no="31" :disabled="true" :value="form.paymentPlaceBL" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.TransportationClause')">
            <el-input no="32" :disabled="true" :value="job.freightTermMBL" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.NoOfOriginalBls')" :class="variableCss.blNumber">
            <el-input v-model="form.blNumber" no="33" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.PlaceOfIssue')">
            <el-input v-model="form.signPlaceBL" no="34" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.DateOfIssue')">
            <el-date-picker v-model="form.signDateBL" no="35" type="date" value-format="yyyy-MM-dd" style="width: 100%" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.BlRemarks')" :class="variableCss.remarks">
            <cargo-rich-textarea
              v-model="form.remarks"
              no="36"
              :disabled="!isEdit"
              :text-chars="maxChars"
              :warning-count="warningCount"
              style="height: 110px;"
              @dblclick.native="showAdvanceTextDialog($t('SeaExport.BlRemarks'),form.remarks,val=>{form.remarks=val})"
            />
          </el-form-item>
        </el-form>
      </div>
      <div class="section form-column">
        <el-form :disabled="readonly" label-width="100px" label-position="right" style="height:100%">
          <span class="title">{{ $t('SeaExport.OtherInfo') }}</span>
          <el-form-item
            v-show="job.typeMBL===BillType.SPLIT_BILL_TYPE.code"
            label-width="0"
            class="auto-width"
          >
            <cargo-ag-grid
              no="37"
              :grid-options="splitOrder.gridOptions"
              :grid-params.sync="splitOrder.gridParams"
              :column-defs="splitOrder.columnDefs"
              :row-data="splitOrderFinalRowData"
              :show-side-bar="false"
              style="width:100%;height:200px"
              @gridReady="params=>{splitOrder.gridApi=params.api}"
            />
            <div style="padding:5px 0">
              <div style="float:right">
                <el-button no="38" type="primary" @click="pm.onAddSplitDocEvent()">{{ $t('Payment.new') }}</el-button>
                <el-button no="39" type="danger" @click="pm.onRemoveSliptDocEvent()">{{ $t('FileHistory.Delete') }}</el-button>
              </div>
            </div>
          </el-form-item>
          <el-form-item
            v-show="job.typeMBL===BillType.MERGE_BILL_TYPE.code"
            label-width="0"
            class="auto-width"
          >
            <cargo-ag-grid
              no="40"
              :grid-options="mergeOrder.gridOptions"
              :grid-params.sync="mergeOrder.gridParams"
              :column-defs="mergeOrder.columnDefs"
              :row-data="mergeOrderFinalRowData"
              :show-side-bar="false"
              style="width:100%;height:200px"
              @gridReady="params=>{mergeOrder.gridApi=params.api}"
            />
            <div style="padding:5px 0">
              <div style="float:right">
                <el-button no="41" type="primary" @click="pm.onJobsAdd()">{{ $t('SeaExport.Add3') }}</el-button>
                <el-button no="42" type="danger" @click="pm.onJobsRemove()">{{ $t('FileHistory.Delete') }}</el-button>
              </div>
            </div>
          </el-form-item>
          <el-form-item :label="$t('SeaExport.BlType')">
            <el-select
              no="43"
              :value="form.releaseType||''"
              @input="val=>{form.releaseType=val}"
              @change="val=>{pm.cmbreleaseTypeMBLChangeHandler(val)}"
            >
              <el-option
                v-for="(item,index) in blModeList"
                :key="index"
                :label="item.name"
                :value="item.serialNumber"
              />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('SeaExport.BillingOfLadingRecordManager')">
            <a
              class="el-button el-button--primary el-button--mini"
              :class="isEdit?'is-disabled':''"
              style="display:inline-block;width: 100%;text-align: center;"
              @click="isEdit?'':statusChangeHistoryDialog.visible=true"
            >……</a>
          </el-form-item>

          <el-form-item :label="$t('SeaExport.ReleasingStatus')" class="red">
            <el-input no="44" :disabled="true" :value="lblReleaseState" />
            <!--            CARGO-40147 放单管理，不允许多次取回-->
            <!--            <label-->
            <!--              v-permission="['button_SingleRelease_singleRelease']"-->
            <!--              :class="btnReleasingDisabled?'not-click':''"-->
            <!--              style="float:right;margin-left:5px"-->
            <!--              @click="pm.btnReleasingClickHandler()"-->
            <!--            >-->
            <!--              <el-button-->
            <!--                no="45"-->
            <!--                :class="btnReleasingDisabled?'is-disabled':'is-enabled'"-->
            <!--                type="primary"-->
            <!--              >{{ form.cfmState === 10 ? $t('SeaExport.CancelReleasing') : $t('SeaExport.Releasing') }}</el-button>-->
            <!--            </label>-->
            <!--            <label-->
            <!--              v-permission="['button_SingleRelease_getBack']"-->
            <!--              :class="btnGetBackDisabled?'not-click':''"-->
            <!--              style="float:right"-->
            <!--              @click="pm.btnGetBackClickHandler()"-->
            <!--            >-->
            <!--              <el-button-->
            <!--                no="46"-->
            <!--                :class="btnGetBackDisabled?'is-disabled':'is-enabled'"-->
            <!--                type="primary"-->
            <!--              >{{ form.bliStatus === 7 ? $t('SeaExport.CancelGetBack') : $t('Message.GetBack') }}</el-button>-->
            <!--            </label>-->
          </el-form-item>
          <el-form-item :label="$t('SeaExport.preverifyDate')">
            <el-date-picker
              v-model="form.reviewDate"
              no="47"
              :disabled="true"
              type="date"
              value-format="yyyy-MM-dd"
              style="width: 100%"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.ReleasingDate')">
            <el-date-picker
              v-model="form.releaseDate"
              no="48"
              :disabled="true"
              type="date"
              value-format="yyyy-MM-dd"
              style="width: 100%"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.DateOfCargoDetention')">
            <el-date-picker
              v-model="form.withholdDate"
              no="49"
              :disabled="true"
              type="date"
              value-format="yyyy-MM-dd"
              style="width: 100%"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.ShippingCompanySCAC')">
            <el-input no="50" :disabled="true" :value="job.carrierScac || txtCarrierScAc" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.OverseasAgentSCAC')">
            <el-input no="51" :disabled="true" :value="txtBookingAgentScAc" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.ContainerAmount')">
            <el-input
              v-model="form.seaeq"
              no="52"
              type="textarea"
              :rows="5"
              style="width:100%"
              @dblclick.native="showAdvanceTextDialog($t('SeaExport.ContainerAmount'),form.seaeq,val=>{form.seaeq=val})"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.CNTRNOSSEALNOS')">
            <el-input
              v-model="form.container"
              no="53"
              type="textarea"
              :rows="5"
              style="width:100%"
              @dblclick.native="showAdvanceTextDialog($t('SeaExport.CNTRNOSSEALNOS'),form.container,val=>{form.container=val})"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.ReasonOfCargoDetention')">
            <el-input no="54" :disabled="true" :value="form.withholdReason" type="textarea" :rows="5" />
          </el-form-item>
        </el-form>
      </div>
    </div>
    <!-- 高级文本弹框 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="advanceTextDialog.visible"
      :title="advanceTextDialog.title"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >

      <cargo-rich-textarea
        v-model="advanceTextDialog.value"
        :text-chars="advanceTextDialog.formatObj.maxChar"
        :auto-uppercase="advanceTextDialog.isUppercase"
        :warning-count="advanceTextDialog.formatObj.warningCount"
        :disabled="!isEdit"
        style="height: 320px;"
      />
      <span slot="footer">
        <el-button v-show="isEdit" no="55" type="primary" @click="finishAdvanceText">{{ $t('common.btn.confirm') }}</el-button>
        <el-button
          no="56"
          @click="advanceTextDialog.visible=false"
        >{{ $t('common.btn.close') }}</el-button>
      </span>
    </el-dialog>
    <!-- 收发通地址弹窗 -->
    <bill-address-dialog :visible.sync="billAddressDialog.visible" :job="job" @callback="codeSearchCallback" />
    <!-- 工作单检索弹窗 -->
    <job-no-transcribe-dialog
      v-if="searchBillNoDialog.visible"
      :visible.sync="searchBillNoDialog.visible"
      lob="SI"
      :params="searchBillNoDialog.params"
      @selected="searchBillNoDialog.selectHandler"
    />
    <!-- 提单日志弹窗 -->
    <status-change-history-dialog
      :visible.sync="statusChangeHistoryDialog.visible"
      :business-data-id="form.uuid"
    />
  </div>
</template>

<script>
import { TabMBL2PM } from './tabMBL2PM'

import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import cargoInput from '@/components/Cargo/Common/cargoInput'
import billAddressDialog from '@/components/Cargo/Job/billAddressDialog'
import statusChangeHistoryDialog from '@/components/Cargo/Job/statusChangeHistoryDialog'
import cargoPackingSelect from '@/components/Cargo/Common/cargoPackingSelect'
import moment from 'moment'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import * as BillType from '@/class/cargo/model/parameters/BillType'
import * as CargoDocConsts from '@/class/cargo/model/parameters/CargoDocConsts'
import { CargoDocUtil } from '@/class/cargo/model/utils/CargoDocUtil'
import { SeaImCargoDoc } from '@/class/model/booking/SeaImCargoDoc'
import { SeaImportJob } from '@/class/model/booking/SeaImportJob'
import jobNoTranscribeDialog from '@/components/Cargo/Job/jobNoTranscribeDialog'
import cargoRichTextarea from '@/components/Cargo/Common/cargoRichTextarea'
import AutoNumberInput from '@/components/Cargo/Common/AutoNumberInput'
import SenderAndReceiver from '@/mixin/SenderAndReceiver'
import ColumnUtils from '@/utils/ColumnUtils'
import { getLoading } from '@/utils/utilBaseElement'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'

export default {
  name: 'TabMbl2',
  components: { cargoRichTextarea, AutoNumberInput, cargoPackingSelect, cargoAdvanceSelect, cargoInput, billAddressDialog, jobNoTranscribeDialog, statusChangeHistoryDialog },
  mixins: [SenderAndReceiver],
  props: {
    context: {
      type: Object,
      required: true
    },
    action: {
      type: String,
      required: true
    },
    cooperateEdit: { // 能否修改
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      ColumnUtils,
      maxChars: 0,
      warningCount: -1,
      englishNameMaxChars: 0,
      markMaxChars: 0,
      englishNameWarningCount: -1,
      markWarningCount: -1,
      visible: false, // 先隐藏，避免组件在初始化完成前，做一些无效的处理（频繁刷新组件、调用接口等）
      pm: new TabMBL2PM(this),
      moment,
      BillType,
      CargoDocConsts,
      CargoDocUtil,
      selectTypeNames: TYPE_NAMES,
      isUppercase: true,
      blModeList: [
        { serialNumber: 1, code: 'ORIGINAL', name: 'ORIGINAL', localName: '正本' },
        { serialNumber: 2, code: 'SURRENDERED', name: 'SURRENDERED', localName: '电放' },
        { serialNumber: 3, code: 'SEA WAYBILL', name: 'SEA WAYBILL', localName: '电放' }
      ],
      addrPM: null, // 提单
      job: {},
      form: new SeaImCargoDoc().fillDefaultValue().getData(),
      lblReleaseState: '',
      txtCarrierScAc: '',
      txtBookingAgentScAc: '',
      command1: this.$t('SeaExport.CodeSearching'),
      variableCss: {
        shipperLine1: '', // 发货人1
        shipperLine2: '', // 发货人2
        shipperLine3: '', // 发货人3
        shipperLine4: '', // 发货人4
        shipperLine5: '', // 发货人5
        shipperLine6: '', // 发货人6
        consigneeLine1: '', // 收货人1
        consigneeLine2: '', // 收货人2
        consigneeLine3: '', // 收货人3
        consigneeLine4: '', // 收货人4
        consigneeLine5: '', // 收货人5
        consigneeLine6: '', // 收货人6
        notifyLine1: '', // 通知人1
        notifyLine2: '', // 通知人2
        notifyLine3: '', // 通知人3
        notifyLine4: '', // 通知人4
        notifyLine5: '', // 通知人5
        notifyLine6: '', // 通知人6
        blNumber: '', // 提单份数
        packing: '', // 包装
        insideQuantity: '', // 小件数
        insidePacking: '', // 小件数包装类型
        dispatchingPlace: '', // (提单发货地)发货地
        weight: '', // 提单毛重
        cubage: '', // 提单体积
        loadingPort: '', // (提单起运港)装货港
        dischargingPort: '', // (提单卸货港)中转港
        destinationPort: '', // (提单交货地)目的港
        cargoEnglishName: '', // 英文品名
        mark: '', // 唛头
        remarks: ''// 备注
      },
      // 拆单
      splitOrder: {
        gridParams: {},
        gridOptions: {
          rowSelection: 'single',
          suppressCellSelection: true,
          suppressRowClickSelection: false,
          context: {
            componentParent: this
          },
          onRowClicked: (e) => this.pm.onSelectionChange(e)
        },
        columnDefs: [
          {
            headerName: this.$t('SeaExport.HblNo2'),
            field: 'hblNbr2',
            width: 130
          },
          {
            headerName: this.$t('SeaExport.MblNo'),
            field: 'mblNbr2',
            width: 130,
            cellRendererFramework: 'agGridColumnEdit',
            custom: {
              tag: 'span'
            }
          }
        ],
        rowData: [],
        gridApi: null
      },
      // 并单
      mergeOrder: {
        gridParams: {},
        gridOptions: {
          rowSelection: 'single',
          suppressCellSelection: true,
          suppressRowClickSelection: false,
          context: {
            componentParent: this
          }
        },
        columnDefs: [
          {
            headerName: this.$t('Payment.businessNumber'),
            colId: 'jobNo',
            field: 'jobNo',
            width: 115
          },
          {
            headerName: this.$t('SeaExport.Quantity'),
            colId: 'quantityActual',
            field: 'quantityActual',
            width: 85
          },
          {
            headerName: this.$t('SeaExport.Weight'),
            colId: 'weightActual',
            field: 'weightActual',
            width: 85
          },
          {
            headerName: this.$t('SeaExport.Cubage'),
            colId: 'cubageActual',
            field: 'cubageActual',
            width: 85
          }
        ],
        rowData: [],
        gridApi: null
      },
      billAddressDialog: {
        visible: false
      },
      searchBillNoDialog: {
        visible: false,
        params: {},
        selectHandler: () => { }
      },
      statusChangeHistoryDialog: {
        visible: false
      },
      addJoinMergeJobList: [], // 当前添加的并单（未保存）
      notUppercaseShipperConsigneNotify: true, // CARGO-47047 收发通大小写控制
      isUppercaseByConfig: true // CARGO-49117 是否大写
    }
  },
  computed: {
    txtFirstVesselVoyage() {
      return (this.job.vessel ? this.job.vessel + ' ' : '') + (this.job.voyageFlight ? this.job.voyageFlight : '')
    },
    readonly() {
      return !this.isEdit
    },
    isEdit() {
      if (!this.cooperateEdit) return false
      return this.action !== 'look' && !this.job.printHblZbLock && (!this.form.uuid || this.form.state < 2)
    },
    btnGetBackDisabled() {
      return this.isEdit || !this.form.uuid
    },
    btnReleasingDisabled() {
      return this.isEdit || !this.form.uuid
    },
    config() {
      return this.context.config
    },
    splitOrderFinalRowData() {
      return this.splitOrder.rowData.filter(p => !p.deleted).sort((a, b) => {
        const suffixA = a.hblNbr2.replace(`${this.job.jobNo}-`, '')
        const suffixB = b.hblNbr2.replace(`${this.job.jobNo}-`, '')
        return suffixA - suffixB
      })
    },
    mergeOrderFinalRowData() {
      return this.mergeOrder.rowData.filter(p => !p.deleted)
    },
    billOfLadingLogStyle() {
      return this.isEdit ? 'width: 100%;text-align: center;cursor: pointer;background-color: rgba(143,186,234,0.66);' : 'width: 100%;text-align: center;cursor: pointer;'
    }
  },
  async created() {
    const loading = getLoading()
    this.context.loading = true
    await this.context.prepareData()
    this.notUppercaseShipperConsigneNotify = await JobUtils.uppercaseShipperConsigneNotify(this.context.config)
    this.isUppercaseByConfig = Number(this.context.config.get('autoUppercaseEnabled')) === 0 // CARGO-49117 英文品名、唛头可以支持小写字 为0就大写 1可以大写可以小写
    this.pm.init()
    this.visible = true
    this.context.loading = false
    loading.close()
  },
  methods: {
    async onShow(row, isRefresh) {
      if (!isRefresh) {
        // 主票 上的mbl 拆单新增记录后 修改提单种类为并单再修改拆单 记录需要清除
        await this.pm.display()
        return
      }
      this.job = row
      this.addJoinMergeJobList = []
      await this.pm.changeJob()
      await this.pm.display()
      await this.pm.fillView()
    },
    getSubmitData() {
      this.pm.validateForm()
      this.pm.fillModel()
      let seaCargoDoc = null
      if (this.job.typeMBL === BillType.SPLIT_BILL_TYPE.code) {
        seaCargoDoc = this.splitOrder.rowData
      } else {
        seaCargoDoc = [this.form]
      }
      return {
        seaCargoDoc,
        mblJoinMergeJobList: this.addJoinMergeJobList,
        job: this.job
      }
    },
    executeTask() {
      this.pm.executeTask()
    },
    commandHandle(command) {
      switch (command) {
        case this.$t('SeaExport.CodeSearching'):
          this.billAddressDialog.visible = true
          break
        case this.$t('SeaExport.CopyFromTheLastTime'):
          this.pm.onCopy1()
          break
        case this.$t('SeaExport.CopyFromOtherBill'):
          Object.assign(this.searchBillNoDialog.params, {
            docType: 'MBL2',
            selectType: 'single',
            jobNo: this.job.jobNo,
            job: { dischargingPortCode: this.job.dischargingPortCode, etd: this.job.etd,
              vessel: this.job.vessel, voyageFlight: this.job.voyageFlight }
          })
          this.searchBillNoDialog.selectHandler = p => { this.pm.selectionItemHandler(p) }
          this.searchBillNoDialog.visible = true
          break
      }
    },
    codeSearchCallback(data) {
      if (data.shipperInfo) {
        this.splitSenderAndReceiverLine('shipper', 7, data.shipperInfo)
      }
      if (data.consigneeInfo) {
        this.splitSenderAndReceiverLine('consignee', 7, data.consigneeInfo)
      }
      if (data.notifyInfo) {
        this.splitSenderAndReceiverLine('notify', 7, data.notifyInfo)
      }
      if (data.hasOwnProperty('shipperCode')) {
        this.form['shipperCode'] = data.shipperCode || ''
      }
      if (data.hasOwnProperty('consigneeCode')) {
        this.form['consigneeCode'] = data.consigneeCode || ''
      }
      if (data.hasOwnProperty('notifyCode')) {
        this.form['notifyCode'] = data.notifyCode || ''
      }
    },
    packageInfoChanged(params) {
      // 拆单专用
      if (this.job.typeMBL === BillType.SPLIT_BILL_TYPE.code) {
        let sum = 0
        for (const item of this.rowData) {
          sum += Number(item[params.field])
        }
        this.form[params.field] = sum
      }
    },
    // 组装打印参数
    getPrintData() {
      if (this.form) {
        const params = {}
        params.cargoDocUuid = this.form.uuid
        params.DOC_UUID = this.form.uuid
        params.category = 'SIMBL2'
        params.ctx = new SeaImportJob(this.job)
        return params
      } else {
        this.$message.warning(this.$t('Message.NoSelectedCargoDocInformation'))
      }
      return null
    }
  }
}
</script>

<style lang="scss" scoped>
.form-column{
  .form-item-input{
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    background-color: #fff;
    border: 1px solid #E4E7ED;
    span{
      width: 40px;
      height: 28px;
      line-height: 26px;
      box-sizing: border-box;
      padding-left: 5px;
      padding-top: 1px;
    }
    /deep/.el-input {
      width: 86%;
      input{
        border: 0;
        padding-right: 0 !important;
        text-align: right;
      }
    }
  }
  .input-disabled{
    background-color: #f0f3f8 !important;
    cursor: not-allowed;
  }
}
</style>
